/* eslint-disable no-nested-ternary */
// TODO: refactor this module to meet 'no-nested-ternary' rule
import _ from 'lodash';
import React, { Component } from 'react';
import update from 'immutability-helper';
import moment from 'moment';
import i18n from '../../config/i18n';
import { REGEX_ZIPCODE } from '../../toolbox/regex';
import InputFile from '../shared/InputFile';
import Select from '../shared/Select';
import defaultAvatarImage from '../../styles/images/no_avatar_image.png';
import {
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
} from '../../constants/RoleConstants';
import {
  GetZipcodeInfo,
  PatientAPIConnectors,
} from '../../api/index';

const styles = {
  table: {
    wrapper: {
      overflowX: 'auto',
    },
    greyOut: {
      opacity: 0.6,
    },
    thead: {
      backgroundColor: '#607484',
      color: '#FFF',
    },
    th: {
      fontSize: 23,
    },
    span: {
      float: 'right',
    },
    avatarWidth: {
      width: '25%',
    },
    label: {
      marginTop: 10,
    },
    address: {
      width: '23%',
      marginRight: 10,
    },
    contact: {
      width: '30%',
      marginRight: 10,
    },
  },
  image: {
    minHeight: 300,
  },
  avatar: {
    container: {
      maxWidth: 400,
      minHeight: 400,
      position: 'relative',
      margin: '10px auto',
    },
  },
  preview: {
    button: {
      marginTop: 10,
      width: '100%',
    },
  },
  zipcode: {
    default: {
      color: 'gainsboro',
      fontSize: 'small',
    },
    error: {
      color: 'red',
      fontSize: 'small',
    },
  },
};
class PatientInfo extends Component {
  constructor(props) {
    super(props);
    const {
      patient: {
        patientDetail: {
          phone,
          email,
          insurance,
          disability,
          avatarUrl,
          address,
          emergencyContact,
        },
      },
    } = this.props;

    this.state = {
      patientInfo: {
        phone: phone || '',
        email: email || '',
        insurance: insurance || '',
        disability: disability || '',
        avatarUrl: avatarUrl || '',
        address: address || {},
        emergencyContact: emergencyContact || {},
      },
      preview: {
        file: null,
        src: '',
        isVisible: false,
      },
      isEditing: false,
      zipcodeDefault: true,
      canUploadPhoto: false,
    };

    this.updateInfo = this.updateInfo.bind(this);
    this.cancel = this.cancel.bind(this);
    this.edit = this.edit.bind(this);
    this.onSelectFile = this.onSelectFile.bind(this);
    this.onUploadAvatar = this.onUploadAvatar.bind(this);
    this.handleCityChange = this.handleCityChange.bind(this);
    this.handleDisabilityChange = this.handleDisabilityChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleEmergencyContactNameChange = this.handleEmergencyContactNameChange.bind(this);
    this.handleEmergencyContactPhoneChange = this.handleEmergencyContactPhoneChange.bind(this);
    this.handleEmergencyContactRelationChange =
      this.handleEmergencyContactRelationChange.bind(this);
    this.handleInsuranceChange = this.handleInsuranceChange.bind(this);
    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.handleStreetChange = this.handleStreetChange.bind(this);
    this.handleZipCodeChange = this.handleZipCodeChange.bind(this);
  }

  onSelectFile(file) {
    this.createImage(file);
  }

  onUploadAvatar = async (e) => {
    const {
      patient: {
        patientDetail: {
          id: medicalRecordId,
        },
      },
      fetchPatientDetailCallback,
    } = this.props;

    e.preventDefault();
    try {
      // Upload image
      const data = await this.uploadImage.uploadWrapper(
        PatientAPIConnectors.uploadPatientPhoto, medicalRecordId
      );

      // Fetch patient detail again
      fetchPatientDetailCallback();
      return data;
    } catch (error) {
      return false;
    }
  }

  setNewAvatarUrl = async () => {
    const {
      patient: {
        patientDetail: {
          id: medicalRecordId,
          photos,
        },
      },
      getPhotoDownloadURLCallback,
    } = this.props;
    const newAvatarUrl = photos.length > 0
      ? await getPhotoDownloadURLCallback(`medical-records/${medicalRecordId}/photos/${photos[photos.length - 1].id}`)
      : '';
    const newPatientInfo = update(this.state.patientInfo, { avatarUrl: { $set: newAvatarUrl } });
    this.setState({
      patientInfo: newPatientInfo,
    });
  }

  setInputsToDefaultValues() {
    const {
      patient: {
        patientDetail: {
          phone,
          email,
          insurance,
          disability,
          address,
          emergencyContact,
        },
      },
    } = this.props;

    this.setState({
      patientInfo: {
        phone,
        email,
        insurance,
        disability,
        address,
        emergencyContact,
      },
      preview: {
        file: null,
        src: '',
        isVisible: false,
      },
    }, () => this.setNewAvatarUrl());
  }

  canEditPatientInfo = () => {
    const { user: { profile: { roleId } } } = this.props;
    return [DOCTOR_ID, ASSISTANT_ID, NURSE_ID].indexOf(roleId) > -1;
  };

  async updateInfo() {
    const {
      actions,
      patient: {
        patientDetail: {
          id: medicalRecordId,
        },
      },
    } = this.props;
    const patient = { ...this.state.patientInfo };
    const result = await actions.updatePatientInfo(patient, medicalRecordId);
    if (result === true) {
      this.setState({
        isEditing: !this.state.isEditing,
      });
    } else {
      this.setInputsToDefaultValues();
    }
  }

  edit() {
    this.setState({
      isEditing: !this.state.isEditing,
      canUploadPhoto: false,
    });
    this.setNewAvatarUrl();
  }

  cancel() {
    this.setState({ isEditing: false });
    this.setInputsToDefaultValues();
  }

  createImage(file) {
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        preview: update(this.state.preview, {
          file: { $set: file },
          src: { $set: reader.result },
          isVisible: { $set: true },
        }),
        canUploadPhoto: true,
      });
    };
    reader.readAsDataURL(file);
  }

  handleInsuranceChange(value) {
    const newPatientInfo = update(this.state.patientInfo,
      { insurance: { $set: value } });
    this.setState({ patientInfo: newPatientInfo });
  }

  handleDisabilityChange(value) {
    const newPatientInfo = update(this.state.patientInfo,
      { disability: { $set: value === '0' } });
    this.setState({ patientInfo: newPatientInfo });
  }

  handlePhoneChange(e) {
    const newPatientInfo = update(this.state.patientInfo,
      { phone: { $set: e.target.value } });
    this.setState({ patientInfo: newPatientInfo });
  }

  handleEmailChange(e) {
    const newPatientInfo = update(this.state.patientInfo,
      { email: { $set: e.target.value } });
    this.setState({ patientInfo: newPatientInfo });
  }

  handleStreetChange(e) {
    const newPatientInfo = update(this.state.patientInfo,
      { address: { street: { $set: e.target.value } } });
    this.setState({ patientInfo: newPatientInfo });
  }

  handleZipCodeChange(e) {
    const zipcode = e.target.value;
    let newPatientInfo = update(this.state.patientInfo,
      { address: { zipcode: { $set: e.target.value } } });
    this.setState({ patientInfo: newPatientInfo });
    if (zipcode.length === 5 && REGEX_ZIPCODE.test(zipcode)) {
      GetZipcodeInfo.getLocation(zipcode)
        .then((data) => {
          if (!_.isEmpty(data)) {
            const { places } = data;
            const {
              'place name': city,
              'state abbreviation': state,
            } = places[0];
            newPatientInfo = update(this.state.patientInfo,
              { address: { city: { $set: city } } });
            this.setState({ patientInfo: newPatientInfo });
            newPatientInfo = update(this.state.patientInfo,
              { address: { state: { $set: state } } });
            this.setState({ patientInfo: newPatientInfo, zipcodeDefault: true });
          }
        });
    }
  }

  handleCityChange(e) {
    const newPatientInfo = update(this.state.patientInfo,
      { address: { city: { $set: e.target.value } } });
    this.setState({ patientInfo: newPatientInfo });
  }

  handleStateChange(e) {
    const newPatientInfo = update(this.state.patientInfo,
      { address: { state: { $set: e.target.value } } });
    this.setState({ patientInfo: newPatientInfo });
  }

  handleEmergencyContactNameChange(e) {
    const newPatientInfo = update(this.state.patientInfo,
      { emergencyContact: { name: { $set: e.target.value } } });
    this.setState({ patientInfo: newPatientInfo });
  }

  handleEmergencyContactPhoneChange(e) {
    const newPatientInfo = update(this.state.patientInfo,
      { emergencyContact: { phone: { $set: e.target.value } } });
    this.setState({ patientInfo: newPatientInfo });
  }

  handleEmergencyContactRelationChange(e) {
    const newPatientInfo = update(this.state.patientInfo,
      { emergencyContact: { relation: { $set: e.target.value } } });
    this.setState({ patientInfo: newPatientInfo });
  }

  render() {
    const {
      table,
      avatar,
      zipcode,
    } = styles;
    const {
      isEditing,
      patientInfo,
      preview,
      zipcodeDefault,
      canUploadPhoto,
    } = this.state;
    const {
      metadata,
      patient: {
        patientDetail,
        isPatientInfoUpdating,
      },
      actions,
    } = this.props;
    const insurance = _.find(metadata.data.insuranceLevel,
      { id: parseInt(patientInfo.insurance, 10) });
    return (
      <div style={table.wrapper}>
        <table
          className="table table-responsive table-bordered patient"
          style={isPatientInfoUpdating ? table.greyOut : {}}
        >
          <thead style={table.thead}>
            <tr>
              <th
                colSpan="6"
                style={table.th}
              >
                {i18n.t('patientInfo')}
                <span style={table.span}>
                  { this.canEditPatientInfo() ? (
                    isEditing ?
                      <div className="btn-group">
                        <button
                          className="btn btn-success btn-sm"
                          onClick={this.updateInfo}
                          disabled={isPatientInfoUpdating}
                        >
                          {i18n.t('update')}
                        </button>
                        <button
                          className="btn btn-default btn-sm"
                          onClick={this.cancel}
                          disabled={isPatientInfoUpdating}
                        >
                          {i18n.t('cancel')}
                        </button>
                      </div> :
                      <button
                        className="btn btn-info btn-sm"
                        onClick={this.edit}
                        disabled={isPatientInfoUpdating}
                      >
                        {i18n.t('edit')}
                      </button>
                  ) : null
                  }
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th width="15%">{i18n.t('id')}</th>
              <td colSpan="4">{patientDetail.identification}</td>
              <td rowSpan="7" style={table.avatarWidth} className="hidden-sm hidden-xs">
                { isEditing
                  ? (
                    <div>
                      <div className="avatarContainer" style={avatar.container}>
                        <img
                          role="presentation"
                          alt={i18n.t('avatar')}
                          src={preview.src || patientInfo.avatarUrl || defaultAvatarImage}
                          style={styles.image}
                          className="img-rounded img-responsive center-block"
                        />
                        <InputFile
                          actions={actions}
                          ref={(ref) => { this.uploadImage = ref; }}
                          onSelectFile={this.onSelectFile}
                          id="files"
                          className="hidden"
                          maxFileSize={104857.6}
                        />
                        <label htmlFor="files">
                          <u style={table.label}>
                            {i18n.t('selectFile')}
                          </u>
                        </label>
                        <button
                          type="button"
                          className="btn btn-success btn-sm"
                          onClick={this.onUploadAvatar}
                          style={styles.preview.button}
                          disabled={!canUploadPhoto}
                        >
                          {i18n.t('upload')}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="avatarContainer" style={avatar.container}>
                      <img
                        src={patientInfo.avatarUrl || defaultAvatarImage}
                        alt={i18n.t('avatar')}
                        width="100%"
                        className="img-rounded img-responsive center-block"
                      />
                    </div>
                  )}
              </td>
            </tr>
            <tr>
              <th>{i18n.t('name')}</th>
              <td>
                {`${_.capitalize(patientDetail.firstName)} ${_.capitalize(patientDetail.lastName)}`}
              </td>
              <th>{i18n.t('ehrId')}</th>
              <td>{patientDetail.originalId || patientDetail.id}</td>
            </tr>
            <tr>
              <th>{i18n.t('gender')}</th>
              <td>{patientDetail.gender}</td>
              <th>{i18n.t('d_o_b')}</th>
              <td>{patientDetail.dateOfBirth ? moment(patientDetail.dateOfBirth).format('YYYY/MM/DD') : ''}</td>
            </tr>
            <tr>
              <th>{i18n.t('phoneNumber')}</th>
              <td>
                { isEditing ? (
                  <input
                    type="text"
                    className="form-control input-sm"
                    value={patientInfo.phone}
                    placeholder={i18n.t('placeholder.phone')}
                    onChange={this.handlePhoneChange}
                  />
                ) : (
                  patientInfo.phone
                )}
              </td>
              <th>{i18n.t('email')}</th>
              <td>
                { isEditing ? (
                  <input
                    type="text"
                    className="form-control input-sm"
                    defaultValue={patientInfo.email}
                    placeholder={i18n.t('email')}
                    onChange={this.handleEmailChange}
                  />
                ) : (
                  patientInfo.email
                )}
              </td>
            </tr>
            <tr>
              <th>{i18n.t('insurance')}</th>
              <td>
                {isEditing ?
                  <Select
                    className="form-control input-sm"
                    value={patientInfo.insurance || ''}
                    onChange={this.handleInsuranceChange}
                    data={metadata.data.insuranceLevel || []}
                  /> : insurance ? insurance.name : ''
                }
              </td>
              <th>{i18n.t('disability')}</th>
              <td>
                { isEditing
                  ? (
                    <Select
                      className="form-control  input-sm"
                      value={patientInfo.disability ? '0' : '1'}
                      onChange={this.handleDisabilityChange}
                      data={[
                        { id: 0, name: i18n.t('yes') },
                        { id: 1, name: i18n.t('no') },
                      ]}
                    />
                  ) : (
                    i18n.t(patientInfo.disability ? 'yes' : 'no')
                  )}
              </td>
            </tr>
            <tr>
              <th>{i18n.t('address')}</th>
              <td colSpan="4" className="form-inline">
                { isEditing ? (
                  <div>
                    <input
                      type="text"
                      className="form-control input-sm"
                      defaultValue={patientInfo.address.street}
                      placeholder={i18n.t('street')}
                      onChange={this.handleStreetChange}
                      style={table.address}
                    />
                    <input
                      type="text"
                      className="form-control input-sm"
                      defaultValue={patientInfo.address.zipcode}
                      placeholder={i18n.t('zipCode')}
                      onChange={this.handleZipCodeChange}
                      style={table.address}
                    />
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientInfo.address.city}
                      placeholder={i18n.t('city')}
                      onChange={this.handleCityChange}
                      style={table.address}
                    />
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientInfo.address.state}
                      placeholder={i18n.t('state')}
                      onChange={this.handleStateChange}
                      style={table.address}
                    />
                    { zipcodeDefault ? (
                      <div style={zipcode.default}>
                        {i18n.t('typeZipCodeToAutoFill')}
                      </div>
                    ) : (
                      <div style={zipcode.error}>
                        {i18n.t('zipCodeNotFound')}
                      </div>
                    )}
                  </div>
                ) : (
                  `${patientInfo.address.street || ''}, ${patientInfo.address.city || ''},
                  ${patientInfo.address.state || ''}, ${patientInfo.address.zipcode || ''}`
                )}
              </td>
            </tr>
            <tr>
              <th>{i18n.t('emergencyContact')}</th>
              <td colSpan="3" className="form-inline">
                { isEditing ? (
                  <div>
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientInfo.emergencyContact.name}
                      placeholder={i18n.t('name')}
                      onChange={this.handleEmergencyContactNameChange}
                      style={table.contact}
                    />
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientInfo.emergencyContact.phone}
                      placeholder={i18n.t('placeholder.phone')}
                      onChange={this.handleEmergencyContactPhoneChange}
                      style={table.contact}
                    />
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientInfo.emergencyContact.relation}
                      placeholder={i18n.t('relationship')}
                      onChange={this.handleEmergencyContactRelationChange}
                      style={table.contact}
                    />
                  </div>
                ) : (
                  <span>
                    <b>{i18n.t('name')}: </b> {`${patientInfo.emergencyContact.name || ''}  `}
                    <b>{i18n.t('phoneNumber')}: </b> {`${patientInfo.emergencyContact.phone || ''}  `}
                    <b>{i18n.t('relationship')}: </b> {`${patientInfo.emergencyContact.relation || ''}  `}
                  </span>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default PatientInfo;



// WEBPACK FOOTER //
// ./src/components/patient/PatientInfo.js